import React from "react";
import { PrimaryButton } from "./PrimaryButton";

const navItems = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

export function SiteHeader({ activeSection, scrollToSection }) {
  return (
    <header className="fixed left-0 right-0 top-0 z-[1000] border-b border-accent bg-surface shadow-sm">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-4 py-4 md:grid md:grid-cols-[1fr_auto_1fr] md:items-center md:gap-4 md:px-10">
        <nav
          className="order-2 flex justify-center gap-6 md:order-1 md:justify-start md:gap-8"
          aria-label="Primary"
        >
          {navItems.map(({ id, label }) => (
            <button
              key={id}
              type="button"
              onClick={() => scrollToSection(id)}
              className={`font-body text-xs font-medium uppercase tracking-[1.5px] transition-colors ${
                activeSection === id
                  ? "text-accent"
                  : "text-ink hover:text-primary"
              }`}
            >
              {label}
            </button>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => scrollToSection("home")}
          className="order-1 text-center font-heading text-xl font-semibold tracking-[0.12em] text-primary md:order-2 md:text-2xl"
        >
          DR. KARIM RAFLA
        </button>

        <div className="order-3 flex justify-center md:justify-end">
          <PrimaryButton type="button" onClick={() => scrollToSection("contact")}>
            Book Consultation
          </PrimaryButton>
        </div>
      </div>
    </header>
  );
}
